import React, { useState } from 'react';
import { Alert, FormControl, IconButton, InputAdornment, TextField } from '@mui/material';
import Button from '../atoms/Button';
import { LoginService } from '../../services/LoginService';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import styles from '../../pages/login/Login.module.css';

const LoginForm: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState('');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleLogin = async (e?: React.FormEvent) => {
    if (e) e.preventDefault();
    if (!validate()) return;

    setLoginError('');
    await LoginService.login(email, password)
      .then((data) => {
        localStorage.setItem('token', data.token);
        localStorage.setItem('token_date', new Date().getTime().toString());
        LoginService.setUserType(data.userType);
        const redirect = searchParams.get('redirect') || '';
        const safeRedirect = redirect.startsWith('/') ? redirect : '';

        if (safeRedirect) {
          navigate(safeRedirect);
          return;
        }

        if (data.userType !== 'USER') navigate('/listar/espaco');
        else navigate('/minhas-solicitacoes');
      })
      .catch((err) => {
        setLoginError(err?.data?.detail || 'Erro ao realizar login');
      });
  };

  const [errors, setErrors] = useState<Record<string, boolean>>({});
  const [showPassword, setShowPassword] = useState(false);

  const validate = () => {
    const newErrors: Record<string, boolean> = {};

    if (!email.trim()) newErrors.email = true;
    if (!password.trim()) newErrors.password = true;

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return (
    <form onSubmit={handleLogin}>
      <div className={styles.formStack}>
        <FormControl fullWidth>
          <TextField
            variant="outlined"
            label="Endereço de e-mail"
            type="email"
            error={!!errors.email}
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              if (loginError) setLoginError('');
            }}
          />
        </FormControl>
        <FormControl fullWidth>
          <TextField
            fullWidth
            label="Senha"
            variant="outlined"
            type={showPassword ? 'text' : 'password'}
            value={password}
            name="senha"
            error={errors.password}
            onChange={(e) => {
              setPassword(e.target.value);
              if (loginError) setLoginError('');
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword(!showPassword)}
                    onMouseDown={(e) => e.preventDefault()}
                    onMouseUp={(e) => e.preventDefault()}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </FormControl>
        {!!loginError && <Alert severity="error">{loginError}</Alert>}
        <FormControl fullWidth>
          <Button
            type="submit"
            variant="contained"
            label="Entrar"
            onClick={handleLogin}
            sx={{
              backgroundColor: '#1f75cf',
              color: '#ffffff',
              fontWeight: 600,
              borderRadius: '6px',
              boxShadow: '0 4px 12px rgba(31, 117, 207, 0.2)',
              '&:hover': {
                backgroundColor: '#1a67b6',
              },
            }}
          />
        </FormControl>
      </div>
    </form>
  );
};

export default LoginForm;
